import React, { useEffect } from "react";
import {Redirect, Route, Switch } from "react-router-dom";
import Landing from "./sections/landing";
import Terms from "./sections/terms";
import Approved from "../global-elements/approved/approved2";
import Declined from "../global-elements/declined";
import { useStoreState, useStoreActions } from "easy-peasy";
import DeclinedTemporal from "../global-elements/declinedTemporal";
import '../../../assets/resultPage/resultpage.css';
import Error404 from "../../systempages/error404/Error404";
import GrandBankPage from "../global-elements/grandbank/grandbankPage";
import Offer from "./sections/offer";
import LinkBankAccount from '../linkBankAccount/linkBankAccount';
import { InactiveDetection } from "../../../services/inactiveDetection";
import ApprovedGrandBank from "../global-elements/approved/approved_grandbank";
import PDFTerms from "../global-elements/PDFTerms";
import { PRODUCT } from "../../../models/websiteTypesConstants";

function Layout() {
  const MainPath      = useStoreState(state => state.siteSettingsModel.MainPath);
  const brandSettings = useStoreState(state => state.siteSettingsModel.brandSettings);
  const termsStep     = useStoreState(state => state.displayPrequalTerms);
  const resultStep    = useStoreState(state => state.displayResult);

  const setProductPath = useStoreActions(actions => actions.siteSettingsModel.setMainPath);

  InactiveDetection.setInactiveTitle(null);
  
  useEffect(() => {
    document.querySelector("title").textContent = `${brandSettings.ProductName} - Mastercard`;
    InactiveDetection.setTitle(`${brandSettings.ProductName} - Mastercard`);
    if(MainPath === "/"){
      setProductPath((window.location.pathname.split("/")[1] === '') ? "/" : "/" + window.location.pathname.split('/')[1] + "/") 
    }
  }, [brandSettings]);

  return (
    <Switch>
      <Route path="/:MainPath/getTerms/:productCode" component={() => <PDFTerms />} exact />
      {/* Landing page No form */}
      <Route path="/" component={() => (MainPath !== "/") ? <Redirect to={"/" + MainPath + window.location.search} /> : <Error404 />} exact />
      <Route path="/:MainPath" component={() => (MainPath !== "/" && "/" + window.location.pathname.split('/')[1] + "/" === MainPath) ? <Landing /> : <Error404 />} exact />
      {/* Terms page No form */}
      <Route path="/:MainPath/terms" component={() => (termsStep) ? <Terms /> : <Redirect to={"/" + window.location.pathname.split('/')[1] + window.location.search} />} exact />
      {/* Approved Page */}
      <Route path="/:MainPath/approved" component={() => (resultStep) ? (brandSettings.ProductName === PRODUCT.Grand.bank ? <ApprovedGrandBank /> : <Approved />) : <Redirect to={"/" + window.location.pathname.split('/')[1] + window.location.search} />} exact />
      {/* Terms page No form */}
      <Route path="/:MainPath/decision" component={() => (resultStep) ? <Declined /> : <Redirect to={"/" + window.location.pathname.split('/')[1] + window.location.search} />} exact />
      <Route path="/:MainPath/grandbank" component={() => (resultStep) ? <GrandBankPage /> : <Redirect to={"/" + window.location.pathname.split('/')[1] + window.location.search} />} exact/>
      <Route path="/:MainPath/pendinfo" component={() => (resultStep) ? <DeclinedTemporal /> : <Redirect to={"/" + window.location.pathname.split('/')[1] + window.location.search} />} exact />
      <Route path="/:MainPath/link-account" component={() => (resultStep) ? <LinkBankAccount /> : <Redirect to={"/" + window.location.search} />} exact />
      {/* Reservation Page */}
      <Route path="/:MainPath/offer" component={() => <Offer />} exact />
      <Route component={() => <Error404 />} />
    </Switch>
  );
}

export default Layout;
